import { Outlet, createRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { Route as authenticatedRoute } from '../route'

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/users',
  component: () => (
    <ProtectedRoute requiredRoles={['admin', 'editor']}>
      <Outlet />
    </ProtectedRoute>
  ),
})
